import { gql } from '@apollo/client';

export const GET_TEAM_MEMBERS = gql`
  query GetTeamMembers($clientId: String!) {
    getTeamMembers(clientId: $clientId) {
      members {
        user {
          _id
          email
          firstName
          lastName
          avatarUrl
        }
        role
        status
        joinedAt
      }
      pendingInvites {
        user {
          _id
          email
        }
        role
        status
        invitedAt
      }
    }
  }
`;

export const GET_INVITATION_BY_TOKEN = gql`
  query GetInvitationByToken($token: String!) {
    getInvitationByToken(token: $token) {
      clientId
      company
      role
      email
      inviterName
      isNewUser
      expiresAt
    }
  }
`;

export const GET_MY_PENDING_INVITATIONS = gql`
  query GetMyPendingInvitations {
    getMyPendingInvitations {
      _id
      company
      teamMembers {
        role
        invitedAt
      }
    }
  }
`;
